export { default } from './AnimationInformationQuizStep';
